import axios from 'axios';
// tslint:disable
import * as React from 'react';
import { Environment } from '../../../environment/environment';
import { Notification } from '../../../index';

export interface ListActions {
    open: (iri: string, target?: string) => void,
    delete: (iri: string, event?: any) => Promise<any>,
    unDelete: (iri: string, event?: any) => Promise<any>,
}

export class ListResponsePresenterTable extends React.Component<any, any> {

    private RENDER_ACTIONS = {

        open: (iri: string, target?: string) => window.open(iri, target || ''),

        delete: async (iri: string): Promise<any> => {
            try {
                const result = await axios.delete(`${Environment.get('api.base')}${iri}`, {withCredentials: true});
                Notification.notify({
                    title: 'Delete is successful',
                    timeer: 3000
                });
                return Promise.resolve(result);
            } catch (err) {
                return Promise.reject(err);
            }
        },
        unDelete: async (iri: string): Promise<any> => {
            try {
                const result = await axios.put(`${Environment.get('api.base')}${iri}?_deletedAt=true`, {'deletedAt': null}, {withCredentials: true});

                Notification.notify({
                    title: 'unDelete is successful',
                    timeer: 3000
                });
                return Promise.resolve(result);
            } catch (err) {
                return Promise.reject(err);
            }
        }
    };

    render() {
        if (this.props.sortable === true) {
            ($('tbody') as any).sortable({
                update: this.props.sortableAction
            }).disableSelection();
        }
        return (
            <div className="w-100 scroll-x mb-3">
                <table className={'table table-bordered table-striped table-condensed ' + (this.props.className || '')} id={this.props.tableId || ''}>
                    <thead>
                    {this.props.head && this.props.head()}
                    </thead>

                    <tbody>
                    {(this.props.items && this.props.items.length && this.props.items.map((item: any, index: number) => this.props.row(item, index, this.RENDER_ACTIONS))) || <tr/>}
                    {(!this.props.items || !this.props.items.length) && <tr>
                        <td colSpan={100}>There is no items!</td>
                    </tr>}
                    </tbody>
                </table>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/structurals/presenters/list-response-presenter-table.tsx